// extracted by mini-css-extract-plugin
export default {"sectionw":"disasters_sectionw__UTxie","donationWrap":"disasters_donationWrap__2ecCP"};